module.exports = __webpack_public_path__ + "img/church_thumbnail-400x300.f821bffd.jpg";